// Import dependencies
import React, {Component} from 'react';
import $ from "jquery";

// Import components
import Grid from "../components/global/Grid";
import ThreeJSComponent from "../components/threejs/ThreeJSComponent";
import { ParagraphText } from "../components/global/UXLibrary";

// Import css
import './Services.css';
import './Menu.css';

// Import images
import menu from '../resources/icons/menu.svg'
import logo from '../resources/icons/logo.svg'

// Define content for the slider
const slider = [
    ['SUPERCHARGED', 'APPLICATIONS', 'With us, you won’t need to prioritise sleek animations over speed or bold designs over responsiveness. With cutting edge javascript frameworks - used to build the world’s most visited websites - you need not tradeoff. Whether it is React’s robustness, Vue’s readiness, Node’s modularity or Angular’s flexibility that fits your needs, these tools fluidly support any fruit of your imagination and slash time to market deployment compared to more rusty technologies providing the optimal ROI.'],
    ['MIND-READING', 'ANALYTICS', 'Validating each of your market guesses through user research is vital to peek into your audience’s head. Given the right tests, metrics and hypothesis formulation; insightful gems emerge. When consulting you or managing your project, our job is to find these insights and improve the product accordingly until it’s perfected. From guerrilla surveys in coffee shops to eye tracking heat maps; we’re all out to listen to those that matter most to your business.'],
    ['IDENTITY', 'BUILDERS', 'We are here to translate the adjectives that make up your brand identity into the shapes, fonts, colour scheme, edge roughness, line thickness and style that transcribe a desired sentiment for the user. Our robust frameworks and infrastructure will allow you to experiment with static designs or dynamic animations -always at 60FPS- in lossless vector quality.'],
    ['MACHINE', 'TRAINERS', 'There is a myriad of patterns ranging from perfect predictability to absolute randomness. To classify faces, forecast trends or synthesise speech we resort to multi-dimensional statistical analysis that consist of cornering these patterns in. With a lead of 3 award winning AI scientists; there’s no machine we can’t train.']
];


export default class Menu extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            textOverlayAnim: '',
            textColour: '#7B7B7F',
            menuAnim: '',
            width: 0,
            displayPhoneNumber: false,
        };
        this.grid = React.createRef();
        this.highlightMenu = this.highlightMenu.bind(this);
        this.tintMenu = this.tintMenu.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    // Animates 'YOUR TECH ARSENAL' tag line on hover
    expandTagline()
    {
        this.setState({
            textOverlayAnim: 'services__expand-text-overlay',
            displayPhoneNumber: true
        })
    }
    contractTagline()
    {
        this.setState({
            textOverlayAnim: 'services__contract-text-overlay',
            displayPhoneNumber: false
        })
    }

    // Focuses elements with a grid
    focusElement = (event) =>
    {
        // Get bounding rectangle of the button
        let location = event.target.getBoundingClientRect();
        // Update grid
        this.grid.current.focus(location.top, location.bottom, location.left, location.right);
    };
    // Resets grid focus
    resetFocus = () =>
    {
        this.grid.current.updateDimensions();
    };

    // Returns random text depending on the class
    randomizeText(text, component)
    {
        let characterCollection = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "R", "S", "T", "U", "V", "Y", "Z"];
        let currentText = text;
        let currentTextCollection = [];
        let characterCount = 0;
        let characterSpeed = 260;

        // Push Current Text Characters
        for (let i = 0; i < currentText.length; i++) {
            let currentCharacter = currentText.slice(i, i+1);
            currentTextCollection.push(currentCharacter);
        }

        let characterCountIncreaseInterval = setInterval(characterCountIncrease, characterSpeed);

        function characterCountIncrease () {
            if (characterCount === currentTextCollection.length) {
                clearInterval(characterCountIncreaseInterval);
                clearInterval(setRandomTextInterval);
            }
            characterCount++;
        }

        function getRandomText () {
            let result = "";

            if (characterCount === 0) {
                for (let i = 0; i < currentTextCollection.length; i++) {
                    result += characterCollection[ Math.floor( Math.random() * characterCollection.length ) ];
                }
            }
            else {
                result = currentText.slice(0, characterCount);

                for (let i = 0; i < currentTextCollection.length - characterCount; i++) {
                    result += characterCollection[ Math.floor( Math.random() * characterCollection.length ) ];
                }
            }
            return result;
        }

        let setRandomTextInterval = setInterval(setRandomText, 25);

        function setRandomText () {
            let newText = getRandomText();
            $(component).text(newText);
        }
    }

    // Animates section title with random characters
    animateSectionTitle()
    {
        // this.randomizeText(slider[this.state.currentSlide][0], ".landing__tagline-1");
        // this.randomizeText(slider[this.state.currentSlide][1], ".landing__tagline-2");
    }

    // Animates menu icon and text on hover
    highlightMenu()
    {
        this.setState({
            menuAnim: 'services__highlight-menu'
        })
    }
    tintMenu()
    {
        this.setState({
            menuAnim: 'services__tint-menu'
        })
    }

    // Updates window dimensions on window resize event
    updateWindowDimensions()
    {
        this.setState({ width: window.innerWidth });
    }

    componentWillMount()
    {
        // Set window resize listener
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount()
    {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    render() {
        return (
            <div className='services__container'>
                <div className='services__top-bar'>
                    {/* Tag line */}
                    <div className='services__tag-line'>
                        <div
                            className='services__top-bar-text'
                            onMouseEnter={(e)=>{ this.expandTagline(); this.focusElement(e) }}
                            onMouseLeave={()=>{ this.contractTagline(); this.resetFocus() }}
                        >
                            {
                                this.state.displayPhoneNumber ?
                                    <a href="tel:+44 800 197 9809">
                                        <ParagraphText className='services__phone-number' style={{ color: this.state.textColour }}>
                                            0 800 197 9809
                                        </ParagraphText>
                                    </a>
                                    :
                                    this.state.width > 480 ?
                                        <ParagraphText style={{
                                            color: this.state.textColour,
                                            position: 'absolute',
                                            left: 0,
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        }}>
                                            BESPOKE TURNKEY SOLUTIONS
                                        </ParagraphText>
                                        :
                                        null
                            }
                        </div>
                        <div className='services__top-bar-indicator' />
                        <div className={'services__top-bar-text-overlay '+this.state.textOverlayAnim} />
                    </div>

                    {/* Menu */}
                    <div
                        className='services__menu'
                        onMouseEnter={(e)=>{ this.highlightMenu(); this.focusElement(e)}}
                        onMouseLeave={()=>{ this.tintMenu(); this.resetFocus() }}
                    >
                        {
                            this.state.width > 480 ?
                                <ParagraphText style={{ pointerEvents: 'none' }} >
                                    MENU
                                </ParagraphText>
                                :
                                null
                        }
                        <img src={menu} className='services__menu-icon' alt='menu-icon' />
                        <div className={'services__menu-overlay '+this.state.menuAnim} />
                    </div>
                </div>

                {/* Left Side (WebGL) */}
                <ThreeJSComponent slide={this.state.currentSlide} />

                {/* Bottom Bar */}
                <div className='services__bottom-bar'>
                    <div className='services__tag-line'>
                        <img src={logo} className='services__bottom-logo' alt='rootnote-logo' />
                    </div>
                    <div className='services__menu'>

                    </div>
                </div>

                {/* Grid */}
                <Grid ref={this.grid} />
            </div>
        );
    }
}
